import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import {
	type TaskAction,
	SetBatchedTaskStatusMutation,
} from '@confluence/fabric-media-support/entry-points/TaskDecisionProvider.ts';
import { mutateInterop } from '@confluence/apollo-relay-interop/entry-points/mutate.ts';
export async function batchTaskUpdate(contentId: string, batch: TaskAction[]) {
	const updateBatch = batch.map((update) => {
		const { objectKey, state } = update;
		const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';

		return { taskId: objectKey.localId, status };
	});

	const taskBatch = {
		contentId,
		tasks: updateBatch,
		trigger: 'VIEW_PAGE',
	};

	try {
		return await mutateInterop({
			mutation: SetBatchedTaskStatusMutation,
			variables: taskBatch,
		});
	} catch (error) {
		const client = await getAnalyticsWebClient();
		client.sendOperationalEvent({
			source: 'page',
			action: 'batchTaskUpdate',
			actionSubject: 'checkbox',
			attributes: {
				error: error.message || String(error),
				stack: error.stack,
			},
		});
	}
}
